module.exports = __webpack_public_path__ + "img/sound.5a6644c2.svg";